<div style="padding: 0 20vw;">
    <mat-card>
        <img src="../../../assets/images/404.png" mat-card-image >
        <h1 class="text-center">Page Not Found</h1>
        <mat-card-actions align="center">
            <button mat-button color="primary" style="font-size: 24px;padding: 16px 32px;" (click)="goBack()">Go Back</button>
        </mat-card-actions>
    </mat-card>
</div>